const KQES_SERVICE_PREFIX = '/api/kqes';
const PREFIX = {
  metaDataManage: '/metadata',
  dataQuery: '/dataquery',
  queryHistory: '/queryhistory',
  saveSql: '/savesql',
  base: '/base',
  jdbc: '/jdbc'
};
export const PATH = {
  base: {
    check: KQES_SERVICE_PREFIX + PREFIX['base'] + '/check',
    billTypeList: KQES_SERVICE_PREFIX + PREFIX['base'] + '/billTypeList',
    isNew: KQES_SERVICE_PREFIX + PREFIX['base'] + '/isnew'
  },
  metaDataManage: {
    // 数据库列表
    dbList: KQES_SERVICE_PREFIX + PREFIX['metaDataManage'] + '/dblist',
    // 数据库的表列表
    dbTables: KQES_SERVICE_PREFIX + PREFIX['metaDataManage'] + '/dbtables',
    // 创建hive数据库
    hiveCreate:
      KQES_SERVICE_PREFIX + PREFIX['metaDataManage'] + '/create/hive/database',
    // 创建RDS数据库
    rdsCreate:
      KQES_SERVICE_PREFIX + PREFIX['metaDataManage'] + '/create/rds/database',
    // 检查同名数据库
    checkDB: KQES_SERVICE_PREFIX + PREFIX['metaDataManage'] + '/dbcheck',
    // 获取rds实例
    RDSInstance:
      KQES_SERVICE_PREFIX + PREFIX['metaDataManage'] + '/rdsinstance',
    // 改变实例授权
    changeRDSAuth:
      KQES_SERVICE_PREFIX + PREFIX['metaDataManage'] + '/changeAuth',
    // 实例下的数据库列表
    instanceDBList:
      KQES_SERVICE_PREFIX + PREFIX['metaDataManage'] + '/query/rds/database',
    // 删除数据库
    dbDrop: KQES_SERVICE_PREFIX + PREFIX['metaDataManage'] + '/drop/database',
    // 创建hive数据表
    hiveTableCreate:
      KQES_SERVICE_PREFIX + PREFIX['metaDataManage'] + '/create/hive/table',
    hiveTableUpdate:
      KQES_SERVICE_PREFIX + PREFIX['metaDataManage'] + '/update/table',

    // 查询表详情
    queryTable:
      KQES_SERVICE_PREFIX + PREFIX['metaDataManage'] + '/query/table/detail',
    // 删除数据表
    delTable: KQES_SERVICE_PREFIX + PREFIX['metaDataManage'] + '/drop/table',
    // 自动解析
    showSchema:
      KQES_SERVICE_PREFIX + PREFIX['metaDataManage'] + '/show/hive/schema',
    checkLocation:
      KQES_SERVICE_PREFIX + PREFIX['metaDataManage'] + '/check/location',
    // bucket 列表
    getBucketList:
      KQES_SERVICE_PREFIX + PREFIX['metaDataManage'] + '/list/bucket',
    // bucket path 列表
    getBucketPathList:
      KQES_SERVICE_PREFIX + PREFIX['metaDataManage'] + '/bucket/listpath'
  },
  dataQuery: {
    // 数据库列表
    dbList: KQES_SERVICE_PREFIX + PREFIX['dataQuery'] + '/dblist',
    // 数据库的表列表
    dbTables: KQES_SERVICE_PREFIX + PREFIX['dataQuery'] + '/dbtables',
    // 表详情
    tableDetail: KQES_SERVICE_PREFIX + PREFIX['dataQuery'] + '/table/detail',
    sqlDetail: KQES_SERVICE_PREFIX + PREFIX['dataQuery'] + '/sql/detail',
    // 运行sql
    runsql: KQES_SERVICE_PREFIX + PREFIX['dataQuery'] + '/runsql',
    // 取消任务
    cancelTask: KQES_SERVICE_PREFIX + PREFIX['dataQuery'] + '/canceltask',
    // 保存sql
    saveSql: KQES_SERVICE_PREFIX + PREFIX['dataQuery'] + '/savesql',
    // 获取bucket地址
    getBucketAddr: KQES_SERVICE_PREFIX + PREFIX['dataQuery'] + '/bucketaddr',
    // 设置bucket地址
    setBucket: KQES_SERVICE_PREFIX + PREFIX['dataQuery'] + '/bucketaddr',
    // 查询运行结果
    getTaskData: KQES_SERVICE_PREFIX + PREFIX['dataQuery'] + '/query/task/data',
    // 查询任务执行状态
    checkTaskStatus:
      KQES_SERVICE_PREFIX + PREFIX['dataQuery'] + '/check/task/status',
    delPath: KQES_SERVICE_PREFIX + PREFIX['dataQuery'] + '/clear/path'
  },
  queryHistory: {
    // 查询任务列表
    getTaskList:
      KQES_SERVICE_PREFIX + PREFIX['queryHistory'] + '/query/task/list',
    // 下载所有结果
    downloadResult:
      KQES_SERVICE_PREFIX + PREFIX['queryHistory'] + '/download/result',
    // 取消任务
    cancelTask: KQES_SERVICE_PREFIX + PREFIX['queryHistory'] + '/cancel/task',
    // 查看结果
    tempResult: KQES_SERVICE_PREFIX + PREFIX['queryHistory'] + '/query/result'
  },
  saveSql: {
    // 查询保存的sql
    getSqlList: KQES_SERVICE_PREFIX + PREFIX['saveSql'] + '/query/sql/list',
    // 删除sql
    delSql: KQES_SERVICE_PREFIX + PREFIX['saveSql'] + '/delsql'
  },
  jdbc: {
    listIamUsers: KQES_SERVICE_PREFIX + PREFIX['jdbc'] + '/listIamUsers',
    setPwd: KQES_SERVICE_PREFIX + PREFIX['jdbc'] + '/resetpwd',
    auth: KQES_SERVICE_PREFIX + PREFIX['jdbc'] + '/dbauthorize'
  }
};
